import { AccountTopUpTour } from "@src/widgets/onboarding/classes/tours/AccountTopUpTour"
import { ApiIntegrationTour } from "@src/widgets/onboarding/classes/tours/ApiIntegrationTour"
import { CryptoPaymentsTour } from "@src/widgets/onboarding/classes/tours/CryptoPaymentsTour"
import { ExchangeTour } from "@src/widgets/onboarding/classes/tours/ExchangeTour"
import { MandatoryInitialSetupTour } from "@src/widgets/onboarding/classes/tours/MandatoryInitialSetupTour"
import { MassCryptoTour } from "@src/widgets/onboarding/classes/tours/MassCryptoTour"
import { OnRampWidgetTour } from "@src/widgets/onboarding/classes/tours/OnRampWidgetTour"
import { SendingInvoicesTour } from "@src/widgets/onboarding/classes/tours/SendingInvoicesTour"
import { TransactionHistoryAndReportsTour } from "@src/widgets/onboarding/classes/tours/TransactionHistoryAndReportsTour"
import { WelcomeTour } from "@src/widgets/onboarding/classes/tours/WelcomeTour"
import {
  ONBOARDING_TOURS,
  PlacementsType,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"

export const ONBOARDING_STEPS_LIST = Object.freeze([
  ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP,
  ONBOARDING_TOURS.API_INTEGRATION,
  ONBOARDING_TOURS.ACCOUNT_TOP_UP,
  ONBOARDING_TOURS.MASS_CRYPTO,
  ONBOARDING_TOURS.EXCHANGE,
  ONBOARDING_TOURS.CRYPTO_PAYMENTS,
  ONBOARDING_TOURS.SENDING_INVOICES,
  ONBOARDING_TOURS.TRANSACTION_HISTORY_AND_REPORTS,
  ONBOARDING_TOURS.ON_RAMP_WIDGET,
])

export const ONBOARDING_TOURS_LABEL_MAP = Object.freeze({
  [ONBOARDING_TOURS.ACCOUNT_TOP_UP]: "Account Top-Up and Withdrawals",
  [ONBOARDING_TOURS.API_INTEGRATION]: "API Integration",
  [ONBOARDING_TOURS.CRYPTO_PAYMENTS]:
    "Accepting Crypto Payments via HTML iFrame",
  [ONBOARDING_TOURS.EXCHANGE]:
    "Crypto-to-Crypto / Crypto-to-Fiat Exchange via dashboard",
  [ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP]: "Mandatory Initial Setup",
  [ONBOARDING_TOURS.MASS_CRYPTO]: "Mass Crypto Payouts via dashboard",
  [ONBOARDING_TOURS.ON_RAMP_WIDGET]: "On-Ramp Widget",
  [ONBOARDING_TOURS.SENDING_INVOICES]: "Sending invoices via payment links",
  [ONBOARDING_TOURS.TRANSACTION_HISTORY_AND_REPORTS]:
    "Transaction History and Reports",
  [ONBOARDING_TOURS.WELCOME]: "Welcome",
})

export const ONBOARDING_TOURS_MAP = Object.freeze({
  [ONBOARDING_TOURS.ACCOUNT_TOP_UP]: new AccountTopUpTour(), // Assuming AccountTopUpTour class exists
  [ONBOARDING_TOURS.API_INTEGRATION]: new ApiIntegrationTour(), // Assuming ApiIntegrationTour class exists
  [ONBOARDING_TOURS.CRYPTO_PAYMENTS]: new CryptoPaymentsTour(), // Assuming CryptoPaymentsTour class exists
  [ONBOARDING_TOURS.EXCHANGE]: new ExchangeTour(), // Assuming ExchangeTour class exists
  [ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP]: new MandatoryInitialSetupTour(),
  [ONBOARDING_TOURS.MASS_CRYPTO]: new MassCryptoTour(), // Assuming MassCryptoTour class exists
  [ONBOARDING_TOURS.ON_RAMP_WIDGET]: new OnRampWidgetTour(), // Assuming SendingInvoicesTour class exists
  [ONBOARDING_TOURS.SENDING_INVOICES]: new SendingInvoicesTour(), // Assuming SendingInvoicesTour class exists
  [ONBOARDING_TOURS.TRANSACTION_HISTORY_AND_REPORTS]:
    new TransactionHistoryAndReportsTour(), // Assuming TransactionHistoryAndReportsTour class exists
  [ONBOARDING_TOURS.WELCOME]: new WelcomeTour(),
})

export const ONBOARDING_STORAGE_KEY = "ONBOARDING_STORAGE"

export const calcPlacement = (element: HTMLElement): PlacementsType | null => {
  if (!window) {
    return null
  }

  const { height: h, width: w } = element.getBoundingClientRect()
  const [paddingY, paddingX, gap] = [40, 48, 40]
  const [height, width] = [h + paddingY, w + paddingX]
  const [centerY, centerX, bottom, top] = [
    { top: innerHeight / 2 - height / 2 },
    { left: gap, right: gap },
    { top: innerHeight - (height + gap * 2) },
    { top: window.scrollY + gap / 2 },
  ]

  return {
    [TOUR_MODAL_PLACEMENTS.BOTTOM]: { ...centerX, ...bottom },
    [TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT]: { left: gap, ...bottom },
    [TOUR_MODAL_PLACEMENTS.BOTTOM_RIGHT]: { right: gap, ...bottom },
    [TOUR_MODAL_PLACEMENTS.CENTER]: { ...centerX, ...centerY },
    [TOUR_MODAL_PLACEMENTS.LEFT]: { left: gap, ...centerY },
    [TOUR_MODAL_PLACEMENTS.RIGHT]: { right: gap, ...centerY },
    [TOUR_MODAL_PLACEMENTS.TOP]: { ...centerX, ...top },
    [TOUR_MODAL_PLACEMENTS.TOP_LEFT]: { left: gap, ...top },
    [TOUR_MODAL_PLACEMENTS.TOP_RIGHT]: { right: gap, ...top },
  }
}
